import Vue from 'vue';
import router from '@/router/index.js';
import Axios from 'axios';
import Cookie from 'js-cookie';
import { loginRole, loginUser, userTokenName } from '@/utils/auth.js';

Axios.defaults.timeout = 100000 // 响应时间
// 本地设置跨域
Axios.defaults.baseURL = process.env.VUE_APP_AXIOS_BASE_URL;// 配置接口地址
//Axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'api' : process.env.VUE_APP_BASE_API
Axios.defaults.withCredentials = true;

// 添加一个请求拦截器 
Axios.interceptors.request.use(
    config => {
        if (Cookie.get(userTokenName)) {
            config.headers.common[userTokenName] = Cookie.get(userTokenName);
            config.headers.deviceInfo = 'pc';
        }
        return config
    },
    error => {
        // _.toast('错误的传参', 'fail')
        return Promise.reject(error)
    }
)

// 响应拦截器
Axios.interceptors.response.use(
    function (response) {
        return response.data
    },
    function (error) {
        if (error.response.status == "408") {
            if (!Cookie.get(userTokenName) || Cookie.get(userTokenName) == '') {
                router.push('/');
            } else {
                Cookie.remove(userTokenName);
                localStorage.removeItem(userTokenName);
                localStorage.removeItem(loginUser);
                localStorage.removeItem(loginRole);
                Vue.prototype.$alert('您的登录已过期，请重新登录！', '', {
                    confirmButtonText: '确定',
                    callback: action => {
                        router.push('/');
                    }
                });
            }
        }
        return Promise.reject(error)
    }
)

export default Axios